import { render, staticRenderFns } from "./ReceiveCompleteNoInvoice.vue?vue&type=template&id=5522d38d&"
import script from "./ReceiveCompleteNoInvoice.vue?vue&type=script&lang=js&"
export * from "./ReceiveCompleteNoInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports